import { FC, Suspense, lazy, useState, useEffect } from 'react';

import { useActions, useShallowEqualSelector } from 'core/redux/hooks';
import { RouteAppComponentProps } from 'types';
import { LoaderFullScreen } from '../controls';
import { selectDaysPastDue } from 'redux/selectors';
import { useExtractUrlParams, useSetuRedirect } from 'hooks';
import { getAppSettings, getUserInfo, getUserLoans, getWPContent } from 'redux/actions';
import useChatWidgetScript from 'hooks/useChatWidgetScript';

interface ILayoutContainerProps extends RouteAppComponentProps {}

const Layout = lazy(() => import('./Layout'));

const LayoutContainer: FC<ILayoutContainerProps> = (props) => {
  const listActions = useActions({
    getWPContent,
    getUserInfo,
    getUserLoans,
    getAppSettings,
  });

  const state = useShallowEqualSelector((state) => ({
    WPContent: state.WPContent,
    user: state.user,
    appSetting: state.user.appSetting,
  }));

  const daysPastDue = useShallowEqualSelector(selectDaysPastDue);

  // check is redirect from setu
  useSetuRedirect();
  // check is payment link and amount
  useExtractUrlParams();

  useEffect(() => {
    listActions.getAppSettings();
  }, [daysPastDue]);

  const isEnabled = state.appSetting?.external?.chat_widget?.is_enabled;
  const widgetId = state.appSetting?.external?.chat_widget?.params?.widget_id;
  const whatsappPhone = state.appSetting?.external?.chat_widget?.params?.whatsapp_phone;

  const [chatWidgetSettings, setChatWidgetSettings] = useState({
    isEnabled: false,
    widgetId: '',
    whatsappPhone: '',
  });

  useEffect(() => {
    isEnabled && widgetId && whatsappPhone &&
    setChatWidgetSettings({
      isEnabled: true,
      widgetId: widgetId,
      whatsappPhone: whatsappPhone,
    });
  }, [widgetId, whatsappPhone, isEnabled]);

  // add OmniWidget script in HTML
  useChatWidgetScript(chatWidgetSettings.isEnabled, chatWidgetSettings.widgetId, chatWidgetSettings.whatsappPhone);

  return (
    <Suspense fallback={<LoaderFullScreen />}>
      <Layout {...props} {...state} {...listActions} />
    </Suspense>
  );
};

export default LayoutContainer;
